import $ from 'jquery/src/jquery'

export function pageScroller(onOff = true) {
    if( pageScroller ) {

    }
}